module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_medium_front_shadow.f03c507b.png";